import { useState } from 'react';

import isError from 'lodash/isError';
import isString from 'lodash/isString';

import { useAlert, useAuth, useNavigate } from '@spotify/confidence-core-react';

type UseAccountLoginResult = {
  error?: Error;
  loading: boolean;
  login: () => Promise<void>;
};

export const useAccountLogin = (loginId: string): UseAccountLoginResult => {
  const navigate = useNavigate();
  const alert = useAlert();
  const [loggingIn, setLoggingIn] = useState(false);
  const { isLoading, loginWithRedirect, error } = useAuth();

  const login = async (): Promise<void> => {
    setLoggingIn(true);
    try {
      await loginWithRedirect({
        authorizationParams: {
          organization: loginId,
        },
      });
      navigate('/');
    } catch (loginError) {
      let errorMessage = 'Something went wrong';
      if (isError(loginError)) {
        errorMessage = loginError.message;
      } else if (isString(loginError)) {
        errorMessage = loginError;
      }
      alert.post({
        severity: 'error',
        message: errorMessage,
      });
    } finally {
      setLoggingIn(false);
    }
  };

  return {
    error,
    loading: isLoading || loggingIn,
    login,
  };
};
